<template>
  <div>
    <div class="mct">
      <div class="mct-card is-basic" id="plan1">
        <div class="mct-card__title">
          <div class="font-bold mct-card__name mct-card__name--basic">
            Free
          </div>
          <div class="flex items-center">
            <div>
              <div class="mct-card__dollar">
                $
              </div>
              <div class="mct-card__currency--asia">
                US
              </div>
            </div>
            <div class="font-bold mct-card__price">
              0
            </div>
          </div>
        </div>
        <div class="mct-card__title-info">
          {{ $i18nPresenter.t('No credit card needed') }}
        </div>
        <div class="mct-card__desc">
          {{ $i18nPresenter.t('Up to 7 live participants') }}
          <br>{{ $i18nPresenter.t('Unlimited questions') }}
          <br>{{ $i18nPresenter.t('Unlimited Quiz') }}
          <br>{{ $i18nPresenter.t('Unlimited Q&A') }}
          <br>
        </div>
        <div class="flex items-center justify-between ">
          <div>
            <div
              v-if="!isShowingDetails('gray')"
              class="mct-card__toggle click-show-details-mobile active gray educational"
              @click="showDetails('gray')"
            >
              {{ $i18nPresenter.t('Show details') }}
            </div>
            <div
              v-else
              class="mct-card__toggle click-hide-details-mobile gray educational"
              @click="hideDetails"
            >
              {{ $i18nPresenter.t('Hide details') }}
            </div>
          </div>
        </div>
        <!-- Show details mobile gray educational-->
        <PricingTableMobile
          v-if="isShowingDetails('gray')"
          subscriptionType="educational"
          type="free"
        />
      </div>
      <div class="mct-card is-yellow" id="plan16">
        <div class="mct-card__title">
          <div class="font-bold mct-card__name mct-card__name--yellow">
            Edu (Small)
          </div>
          <div class="flex items-center">
            <div>
              <div class="mct-card__dollar">
                $
              </div>
              <div class="mct-card__currency--asia">
                US
              </div>
            </div>
            <div class="font-bold mct-card__price">
              <span>2</span>
            </div>
            <div class="mct-card__price mct-card__smaller-price">
              95
            </div>
            <div class="mct-card__legend">
              <div class="mct-card__year">
                / {{ $i18nPresenter.t('month') }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between">
          <div class="mct-card__title-info">
            {{ $i18nPresenter.t('All Free plus:') }}
          </div>
          <div class="text-xs mct-card__title-info">
            {{ $i18nPresenter.t('Billed annually') }}
          </div>
        </div>
        <div class="mct-card__desc">
          <span v-html="$i18nPresenter.t('upto25liveParticipants')"></span>
          <br>{{ $i18nPresenter.t('Participant data export') }}
          <br>
        </div>
        <div class="flex items-center justify-between ">
          <div>
            <div
              v-if="!isShowingDetails('yellow')"
              class="mct-card__toggle click-show-details-mobile active yellow educational"
              @click="showDetails('yellow')"
            >
              {{ $i18nPresenter.t('Show details') }}
            </div>
            <div
              v-else
              class="mct-card__toggle click-hide-details-mobile yellow educational"
              @click="hideDetails"
            >
              {{ $i18nPresenter.t('Hide details') }}
            </div>
          </div>
          <a>
            <button
              class="action-button action-button--34 action-button--yellow"
              type="button"
              @click="$emit('upgradePlan', 'edu-small-yearly')"
              :disabled="permission.eduSmallYearly"
            >{{ $i18nPresenter.t('Upgrade') }}</button>
          </a>
        </div>
        <!-- Show details mobile yellow educational -->
        <PricingTableMobile
          v-if="isShowingDetails('yellow')"
          subscriptionType="educational"
          type="essential"
        />
      </div>
      <!-- Show details mobile green educational -->
      <div class="mct-card is-green" id="plan17">
        <div class="mct-card__title">
          <div class="font-bold mct-card__name mct-card__name--green">
            Edu (Medium)
          </div>
          <div class="flex items-center">
            <div>
              <div class="mct-card__dollar">
                $
              </div>
              <div class="mct-card__currency--asia">
                US
              </div>
            </div>
            <div class="font-bold mct-card__price">
              <span>5</span>
            </div>
            <div class="mct-card__price mct-card__smaller-price">
              45
            </div>
            <div class="mct-card__legend">
              <div class="mct-card__year">
                / {{ $i18nPresenter.t('month') }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between">
          <div class="mct-card__title-info">
            {{ $i18nPresenter.t('All Free plus:') }}
          </div>
          <div class="text-xs mct-card__title-info">
            {{ $i18nPresenter.t('Billed annually') }}
          </div>
        </div>
        <div class="mct-card__desc">
          <span v-html="$i18nPresenter.t('upto50liveParticipants')"></span>
          <br>{{ $i18nPresenter.t('Participant data export') }}
          <br>
        </div>
        <div class="flex items-center justify-between ">
          <div>
            <div
              v-if="!isShowingDetails('green')"
              class="mct-card__toggle click-show-details-mobile active green educational"
              @click="showDetails('green')"
            >
              {{ $i18nPresenter.t('Show details') }}
            </div>
            <div
              v-else
              class="mct-card__toggle click-hide-details-mobile green educational"
              @click="hideDetails"
            >
              {{ $i18nPresenter.t('Hide details') }}
            </div>
          </div>
          <a>
            <button
              class="action-button action-button--34 action-button--green"
              type="button"
              @click="$emit('upgradePlan', 'edu-medium-yearly')"
              :disabled="permission.eduMediumYearly"
            >{{ $i18nPresenter.t('Upgrade') }}</button>
          </a>
        </div>
        <!-- Show details mobile green educational-->
        <PricingTableMobile
          v-if="isShowingDetails('green')"
          subscriptionType="educational"
          type="plus"
        />
      </div>
      <div class="mct-card is-purple" id="plan18">
        <div class="mct-card__title">
          <div class="font-bold mct-card__name mct-card__name--purple">
            Edu (Large)
          </div>
          <div class="flex items-center">
            <div>
              <div class="mct-card__dollar">
                $
              </div>
              <div class="mct-card__currency--asia">
                US
              </div>
            </div>
            <div class="font-bold mct-card__price">
              7
            </div>
            <div class="mct-card__price mct-card__smaller-price">
              65
            </div>
            <div class="mct-card__legend">
              <div class="mct-card__year">
                / {{ $i18nPresenter.t('month') }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between">
          <div class="mct-card__title-info">
            {{ $i18nPresenter.t('All Free plus:') }}
          </div>
          <div class="text-xs mct-card__title-info">
            {{ $i18nPresenter.t('Billed annually') }}
          </div>
        </div>
        <div class="mct-card__desc">
          <span v-html="$i18nPresenter.t('upto200liveParticipants')"></span>
          <br>{{ $i18nPresenter.t('Participant data export') }}
          <br>
        </div>
        <div class="flex items-center justify-between">
          <div>
            <div
              v-if="!isShowingDetails('purple')"
              class="mct-card__toggle click-show-details-mobile active purple educational"
              @click="showDetails('purple')"
            >
              {{ $i18nPresenter.t('Show details') }}
            </div>
            <div
              v-else
              class="mct-card__toggle click-hide-details-mobile purple educational"
              @click="hideDetails"
            >
              {{ $i18nPresenter.t('Hide details') }}
            </div>
          </div>
          <a>
            <button
              class="action-button action-button--34 action-button--purple"
              type="button"
              @click="$emit('upgradePlan', 'edu-large-yearly')"
              :disabled="permission.eduLargeYearly"
            >{{ $i18nPresenter.t('Upgrade') }}</button>
          </a>
        </div>
        <!-- Show details mobile purple educational-->
        <PricingTableMobile
          v-if="isShowingDetails('purple')"
          subscriptionType="educational"
          type="pro"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import PricingTableMobile from './PricingTableMobile.vue'

export default {
  components: {
    PricingTableMobile,
  },
  props: {
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      planType: '',
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    showDetails(planType) {
      this.planType = planType
      const planColorMap = {
        gray: 'edu-free',
        yellow: 'edu-small',
        green: 'edu-medium',
        purple: 'edu-large',
      }
      Utils.mixpanelTracking(eventCategories.MY_PLAN, 'Show details', planColorMap[planType])
    },
    hideDetails() {
      this.planType = ''
    },
    isShowingDetails(planType) {
      return planType === this.planType
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.active {
  display: block !important;
}

.mct-card__year {
  font-size: 12px;
}

.mct-card__legend {
  margin-left: 5px;
}

.action-button {
  border-radius: 20px;
  border: 0;
  color: #fff;
  cursor: pointer;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: 0.15s linear;
}

.action-button:focus {
  outline: none;
}

.action-button--34 {
  height: 34px;
  line-height: 34px;
}

.action-button--basic {
  background-color: #808080;
}

.action-button--basic:hover {
  box-shadow: 0 1px 10px rgba(128, 128, 128, 0.4);
}

.action-button--green {
  background-color: #28c270;
}

.action-button--green:hover {
  box-shadow: 0 1px 10px rgba(40, 194, 112, 0.4);
}

.action-button--yellow {
  background-color: #ffae09;
}

.action-button--yellow:hover {
  box-shadow: 0 1px 10px rgba(255, 174, 9, 0.4);
}

.action-button--purple {
  background-color: #7669bf;
}

.action-button--purple:hover {
  box-shadow: 0 1px 10px rgba(118, 105, 191, 0.4);
}

//Mobile
.mct {
  background: -o-radial-gradient(center, ellipse, #e6e6e6 0%, #fff 70%);
  background: radial-gradient(ellipse at center, #e6e6e6 0%, #fff 70%);
}

@media (min-width: 540px) {
  .mct {
    padding: 20px;
  }
}

.mct-card {
  background-color: #fff;
  padding: 20px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 539px) {
  .mct-card {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}

@media (min-width: 540px) {
  .mct-card {
    border-radius: 5px;
    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    margin-bottom: 15px;
  }
}

@media (max-width: 479px) {
  .action-button {
    font-size: 11px;
    width: 120px;
    font-weight: bold;
  }
}

@media (min-width: 480px) {
  .action-button {
    font-size: 12px;
    padding: 0 20px;
    font-weight: bold;
    height: 35px;
    line-height: 37px;
  }
}

button {
  cursor: pointer;
  width: 110px;
}

button:disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
}
@media (max-width: 500px) {
  .mct-card {
    padding-left: 10px;
    padding-right: 10px;
  }
}
.mct-card__dollar {
  margin-top: 8px;
}
.mct-card__currency--asia {
  font-size: 8px;
  margin-top: -4px;
}
.mct-card__price {
  font-size: 26px;
  margin-left: 5px;
}
.mct-card__smaller-price {
  font-size: 12px;
  margin-top: -11px;
  margin-left: 2px;
}
.mct-card__desc {
  color: #666;
  font-size: 15px;
}
.mct-card__toggle {
  color: rgba(0, 0, 0, 0.4);
  text-decoration: underline;
  cursor: pointer;
}
.mct-card__title {
  color: rgba(0, 0, 0, 0.6);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.mct-card__name {
  color: rgba(0, 0, 0, 0.6);
  font-size: 24px;
  @media screen and (max-width: 360px) {
    font-size: 20px;
  }
  @media screen and (max-width: 324px) {
    font-size: 18px;
  }
}

.mct-card__name--basic {
  color: #808080;
}

.mct-card__name--yellow {
  color: #ffae09;
}

.mct-card__name--green {
  color: #28c270;
}

.mct-card__name--purple {
  color: #7669bf;
}
</style>
